import React, {MouseEventHandler} from 'react';
import Button, {ButtonProps} from "@mui/material/Button";
import {styled} from "@mui/material";
import {HILIGHT_COLOR} from "../constants/constants";

interface AlfyButtonProps {
    text: string,
    onClick: MouseEventHandler
    disabled?: boolean | undefined
}

export const AlfyButton: React.FC<AlfyButtonProps> = ({ text, onClick, disabled = false }) => {
    return (
        <CustomButton onClick={onClick} disabled={disabled}>{text}</CustomButton>
    );
}

const CustomButton = styled(Button)<ButtonProps>(({ disabled }) => ({
    color: disabled ? '#555555' : '#fff',
    backgroundColor: disabled ? '#fff' : HILIGHT_COLOR,
    border: disabled ? '1px solid #D9D9D9' : '1px solid ' + HILIGHT_COLOR,
    fontSize: '16px',
    fontWeight: 700,
    width: '100%',
    height: '56px',
    '&:hover': {
        backgroundColor: disabled ? '#fff' : HILIGHT_COLOR,
        borderColor: disabled ? '#D9D9D9' : HILIGHT_COLOR,
    }
}))